import merge from 'lodash/merge';
import { button } from './components/button';
import { textField } from './components/textfield';
import { switches } from './components/switch';
import { appBar } from './components/appbar';
import { table } from './components/table';
import { checkbox } from './components/checkbox';
import { dialog } from './components/dialog';
import { dataGrid } from './components/data-grid';
import { chip } from './components/chip';
import { select } from './components/select';
import { typography } from './components/typography';
import { datePicker } from './components/date-picker';
import { toggleButton } from './components/toggle-button';
import { interaction } from './components/interaction';
// ----------------------------------------------------------------------
export function componentsOverrides(theme, quietMotion = true) {
    const components = merge(interaction(theme, quietMotion), button(theme, quietMotion), textField(theme), switches(theme), appBar(theme), table(theme), dataGrid(theme), dialog(theme), checkbox(theme), toggleButton(theme), chip(theme), select(theme), typography(theme), datePicker(theme));
    return components;
}
